import React from 'react';

const GradientSection = ({ children, className = '', id = '' }) => {
    return (
        <div
            id={id}
            className={`w-full rounded-[24px] relative overflow-hidden ${className}`}
            style={{ background: 'var(--gradient-primary)' }}
        >
            {children}
        </div>
    );
};

export default GradientSection;
